import { mkdirSync } from "node:fs";
import { dirname, join } from "node:path";
import Database from "better-sqlite3";
import { dataDir } from "../lib/paths";
import { DDL, SCHEMA_VERSION } from "./schema";

export function defaultDbPath(): string {
  return join(dataDir(), "tktuner.db");
}

export function openDb(path?: string): Database.Database {
  const dbPath = path ?? defaultDbPath();
  mkdirSync(dirname(dbPath), { recursive: true });
  const db = new Database(dbPath);
  db.pragma("journal_mode = WAL");
  migrate(db);
  return db;
}

function migrate(db: Database.Database): void {
  rebuildIfPreRelease(db);
  db.exec(DDL);
  const row = db.prepare(`SELECT value FROM meta WHERE key = 'schema_version'`).get() as
    | { value: string }
    | undefined;
  const current = row ? Number(row.value) : 0;
  if (current > SCHEMA_VERSION) {
    throw new Error(
      `Database schema v${current} is newer than this tktuner build supports (v${SCHEMA_VERSION}). Upgrade tktuner.`,
    );
  }
  // v1 is the baseline; future versions add ALTERs gated on `current` here.
  db.prepare(
    `INSERT INTO meta (key, value) VALUES ('schema_version', ?)
     ON CONFLICT(key) DO UPDATE SET value = excluded.value`,
  ).run(String(SCHEMA_VERSION));
}

/**
 * Everything in the db derives from the JSONL logs, so an old-shape database
 * is rebuilt rather than migrated (rescanning is cheap). Detects pre-release
 * schemas by the absence of turns.message_id.
 */
function rebuildIfPreRelease(db: Database.Database): void {
  const table = db
    .prepare(`SELECT name FROM sqlite_master WHERE type = 'table' AND name = 'turns'`)
    .get();
  if (!table) return;
  const cols = db.prepare(`PRAGMA table_info(turns)`).all() as { name: string }[];
  if (cols.some((c) => c.name === "message_id")) return;
  db.exec(`DROP TABLE IF EXISTS turns; DROP TABLE IF EXISTS events; DROP TABLE IF EXISTS files;`);
}
